'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Loader overlay : will block access to element using a loading overlay
 */
ngModule.directive('tlLoaderOverlay', function () {
  return {
    restrict: "E",
    template: "<div class='tl-loader-overlay'>" + "   <tl-circular-loader></tl-circular-loader>" + "</div>"
  };
});

/**
 * Modal overlay : will block access to element using an overlay
 *
 * Control of the state of the overlay is done by setting the tl-model-overlay attrivute
 */
ngModule.directive('tlModalOverlay', function () {
  return {
    restrict: "A",
    link: function link($scope, $el, $attrs, ctrl) {
      ctrl.loader = $("<div class='tl-blocker-overlay'></div>");
      $el.append(ctrl.loader);
      ctrl.hideLoader();
      $scope.$watch($attrs.tlModalOverlay, function (enabled) {
        enabled ? ctrl.showLoader() : ctrl.hideLoader();
      });
    },
    controller: function controller($scope) {
      var ctrl = this;
      ctrl.showLoader = function () {
        ctrl.loader.show();
      };
      ctrl.hideLoader = function () {
        ctrl.loader.hide();
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlLoaderOverlay.js
// module id = 2904
// module chunks = 13